// src/modules/employees/employeeService.js
// Field-employee management. Employees are Users with role 'employee'; this
// service scopes the shared /users admin endpoints to that role.
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL + '/users';
const getAuthToken = () => localStorage.getItem('token');
const getHeaders = () => ({ headers: { Authorization: `Bearer ${getAuthToken()}` } });

// All users with role 'employee'.
export const listEmployees = async () => {
  try {
    const response = await axios.get(`${API_URL}/`, getHeaders());
    return (response.data || []).filter((u) => u.role === 'employee');
  } catch (error) {
    console.error('Error fetching employees:', error);
    throw error;
  }
};

export const getEmployee = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/profile/${id}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error(`Error fetching employee ${id}:`, error);
    throw error;
  }
};

// Uses the admin-create endpoint so the role is set at creation time.
export const createEmployee = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/admin/create`, { ...data, role: 'employee' }, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error creating employee:', error);
    throw error;
  }
};

export const updateEmployee = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}/admin/update/${id}`, { ...data, role: 'employee' }, getHeaders());
    return response.data;
  } catch (error) {
    console.error(`Error updating employee ${id}:`, error);
    throw error;
  }
};

export const deleteEmployee = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/admin/delete/${id}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error(`Error deleting employee ${id}:`, error);
    throw error;
  }
};
